// import config from "../service/config"
import moment from "moment"
export function setCookie(cookieName, cookieValue) {
document.cookie = cookieName + "=" + cookieValue + ";path=/"
}
export function getCookie(cookieName) {
const nameEQ = cookieName + "="
const cookieArr =
typeof document !== "undefined" ? document.cookie.split(";") : []
for (var i = 0; i < cookieArr.length; i++) {
var c = cookieArr[i]
while (c.charAt(0) === " ") {
c = c.substring(1, c.length)
}
if (c.indexOf(nameEQ) === 0) {
return c.substring(nameEQ.length, c.length)
}
}
return null
}
export function eraseCookie(cookieName) {
document.cookie =
cookieName + "=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/"
if (getCookie(cookieName)) {
}
}
export function slugify(text) {
    if (text) {
return text
.toString()
.toLowerCase()
.replace(/\s+/g, "-") // Replace spaces with -
.replace(/[^\w\-]+/g, "") // Remove all non-word chars
.replace(/\-\-+/g, "-") // Replace multiple - with single -
.replace(/^-+/, "") // Trim - from start of text
.replace(/-+$/, "") // Trim - from end of text
    }
}
export function objectDeepClone(obj) {
return JSON.parse(JSON.stringify(obj))
}
export function formatEventDate(date) {
if (date) {
return moment(date).format("Do MMM YYYY")
}
return null
}
export function formatAppointmentDate(date) {
if (date) {
return moment(date, 'DD-MM-YYYY').format("Do MMMM, YYYY")
}
return null
}
export function formatEventRegDate(date) {
if (date) {
return moment(date).format("DD MMMM YYYY")
}
return null
}
export function dateToYear(date) {
if (date) {
return moment(date).format("YYYY")
}
return null
}
export function monthFromYear(date) {
if (date) {
return moment(date).format("DD MMMM")
}
return null
}
export function formatAwardDate(date) {
if (date) {
return moment(date).format("MMMM DD, YYYY")
}
return null
}
export function format24To12HoursTime(time) {
if (time) {
return moment(time, ["HH:mm"]).format("h:mm A")
} else return ""
}
export function getMonthAndYear(date) {
if (date) {
return moment(date).format("MMM YYYY")
}
return null
}
export function getDay(date) {
if (date) {
return moment(date, 'DD-MM-YYYY').format("ddd")
}
return null
}
export function getDate(date) {
if (date) {
return moment(date, 'DD-MM-YYYY').format("D")
}
return null
}
export function getMonth(date) {
if (date) {
return moment(date, 'DD-MM-YYYY').format("MMM")
}
return null
}
export function getYear(date) {
if (date) {
return moment(date, 'DD-MM-YYYY').format("YYYY")
}
return null
}
export function acceptOnlyNumbers(str) {
    if (str) {
        return str.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1')
    }
    return null
}
export function formatAmount(amount) {
    if (amount) {
        let amountStr = amount.toString();
        let amountArr = amountStr.split('.')
        amountStr = amountArr?.[0]
        var lastThree = amountStr.substring(amountStr.length-3);
        var otherNumbers = amountStr.substring(0,amountStr.length-3);
        if(otherNumbers !== '')
            lastThree = ',' + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        if(amountArr?.length === 2) {
            return res+'.'+amountArr?.[1]
        } else {
            return res
        }
        
    }
    return null
}
export const getNameInitials = (str) => {
    if(str === 'NA') return str
    if(str) {
        let names = str.split(' ')
        let initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    }
    return null
}
export function getLowerCaseNoSpace(str) {
if (str) {
return str.toLowerCase().replace(/\s/g, '')
}
return null
}
export function checkIfValidJSON(text) {
try {
return (JSON.parse(text) && !!text);
} catch (e) {
return false;
}
}
export function getYouTubeId(url) {
const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
const match = url.match(regExp)
return match && match[2].length === 11 ? match[2] : null
}
export const getVideoThumbnail = videoURL => {
if (videoURL && getYouTubeId(videoURL)) {
return (
"https://img.youtube.com/vi/" + getYouTubeId(videoURL) + "/hqdefault.jpg"
)
}
return null
}
export const getBannerVideoThumbnail = videoURL => {
if (videoURL && getYouTubeId(videoURL)) {
return (
"https://img.youtube.com/vi/" + getYouTubeId(videoURL) + "/sddefault.jpg"
)
}
return null
}


export const compareDates = (apiDateOG, eventDateOG) => {
    const apiDate = moment(apiDateOG, 'DD-MM-YYYY: HH:mm A').valueOf()
    const eventDate = moment(eventDateOG+': 11:00 PM', 'YYYY-MM-DD: HH:mm A').valueOf()
    // 18-04-2022: 16:36 PM           
    // 2019-02-03
    if (apiDate > eventDate) {
        return false
    } else {
        return true
    }
}

export const concealMobileNo = (mobile_no) => {
    if(mobile_no) {
        return mobile_no.replace(/^.{7}/g, '*******')
    }
    return null
}

export const urlQueryToString = (str) => {
    if(str) {
        return str.replaceAll("%20", " ");
    }
    return null
}

export const convertArrToStr = (arr) => {
    if(arr?.length) {
        let str = ''
        arr.forEach((el, i) => {
            str = str + el?.name+`${(arr?.length -1) === i ? '.' : ', '}`
        })
        return str
    }
    return ''
}

export const checkMeridiem = (time) => {
    if(time) {
        let arr = time?.split(':')
        if(arr?.[0] >= 12) {
            return 'PM'
        } else {
            return 'AM'
        }
    }
    return 'NA'
}

export const formatPaymentDateTime = (date, time) => {
    if(date && time) {
        let tArr = []
        if(date.includes('-')) {
            tArr = date?.split('-')
        } else {
            tArr = date?.split('/')
        }
        let t = `${tArr[1]+'-'+tArr[0]+'-'+tArr[2]}`
        let tarik = moment(t).format("DD-MMM-yyyy")
        let arr = time?.split(':')
        if(arr?.[0] >= 12) {
            return `${tarik +' '+arr.join(' ')+ ' PM'}`
        } else {
            return `${tarik +' '+arr.join(' ')+ ' AM'}`
        }
    }
    return 'NA'
}

export const formatTodayDateTime = () => {
    let todayDateAndTime = moment(new Date()).format("DD-MMM-YYYY hh mm A")
    return todayDateAndTime
}

export const generateUniqueId = (n = 8) => {
    let uniqueId = (Math.floor(Date.now() + Math.random() * (9 * (Math.pow(10, n)))) + (Math.pow(10, n))).toString();
    uniqueId = uniqueId.slice(uniqueId.length - 8)
    return uniqueId
}
  
export function addMinutesInTime(time, minutes) {
if (time) {
return moment.utc(time,'hh:mm').add(minutes,'minutes').format('hh:mm')
}
return null
}